'use client';

import { forwardRef, InputHTMLAttributes } from 'react';

interface InputFieldProps extends InputHTMLAttributes<HTMLInputElement> {
  hasError?: boolean;
}

const InputField = forwardRef<HTMLInputElement, InputFieldProps>(
  ({ hasError, className = '', ...props }, ref) => {
    return (
      <input data-component-id="src/app/provider-profile-form/components/InputField.tsx:12:6" data-component-path="src/app/provider-profile-form/components/InputField.tsx" data-component-line="12" data-component-end-line="26" data-component-file="InputField.tsx" data-component-name="input" data-component-content="%7B%22elementName%22%3A%22input%22%2C%22%5Bspread%5D%22%3A%22true%22%7D"
        ref={ref}
        className={`
          w-full h-10 px-3 rounded-lg border text-sm font-medium text-foreground bg-white
          placeholder:text-muted-foreground placeholder:font-normal
          transition-all duration-150
          focus:outline-none focus:ring-2 focus:ring-primary/30 focus:border-primary
          disabled:opacity-50 disabled:cursor-not-allowed disabled:bg-muted
          ${hasError
            ? 'border-destructive focus:ring-destructive/20 focus:border-destructive bg-destructive/5' :'border-input hover:border-primary/50'
          }
          ${className}
        `}
        {...props}
      />
    );
  }
);

InputField.displayName = 'InputField';
export default InputField;